import { render, staticRenderFns } from "./generalChange.vue?vue&type=template&id=160e11c0"
import script from "./generalChange.vue?vue&type=script&lang=js"
export * from "./generalChange.vue?vue&type=script&lang=js"
import style0 from "./generalChange.vue?vue&type=style&index=0&id=160e11c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports